import { createStore } from 'vuex'
import operate_inspection_plan_product from './inspection_plan_product'
import operate_inspection_plan_inspection from './inspection_plan_inspection'

const store = createStore({
  actions: {
    clearAllStores({ dispatch }) {
      dispatch('operate_inspection_plan_product/clearAll', null, { root: true })
      dispatch('operate_inspection_plan_inspection/clearAll', null, { root: true })
    },
    clearDataStores({ dispatch }) {
      dispatch('operate_inspection_plan_product/clearAll', null, { root: true })
      dispatch('operate_inspection_plan_inspection/clearAll', null, { root: true })
    },
  },
  modules: {
    operate_inspection_plan_product,
    operate_inspection_plan_inspection,
  },
})

export default store
